__turbopack_context__.v({
  "capabilities": "landing-sections-module__gkwj3G__capabilities",
  "capability": "landing-sections-module__gkwj3G__capability",
  "container": "landing-sections-module__gkwj3G__container",
  "cta": "landing-sections-module__gkwj3G__cta",
  "ctaButton": "landing-sections-module__gkwj3G__ctaButton",
  "eyebrow": "landing-sections-module__gkwj3G__eyebrow",
  "footer": "landing-sections-module__gkwj3G__footer",
  "footerBottom": "landing-sections-module__gkwj3G__footerBottom",
  "footerColumns": "landing-sections-module__gkwj3G__footerColumns",
  "footerHeading": "landing-sections-module__gkwj3G__footerHeading",
  "footerLink": "landing-sections-module__gkwj3G__footerLink",
  "footerList": "landing-sections-module__gkwj3G__footerList",
  "footerText": "landing-sections-module__gkwj3G__footerText",
  "h2": "landing-sections-module__gkwj3G__h2",
  "h3": "landing-sections-module__gkwj3G__h3",
  "intro": "landing-sections-module__gkwj3G__intro",
  "lead": "landing-sections-module__gkwj3G__lead",
  "panel": "landing-sections-module__gkwj3G__panel",
  "panelItem": "landing-sections-module__gkwj3G__panelItem",
  "panelList": "landing-sections-module__gkwj3G__panelList",
  "panelTitle": "landing-sections-module__gkwj3G__panelTitle",
  "pictogram": "landing-sections-module__gkwj3G__pictogram",
  "row": "landing-sections-module__gkwj3G__row",
  "rowReverse": "landing-sections-module__gkwj3G__rowReverse",
  "rowText": "landing-sections-module__gkwj3G__rowText",
  "section": "landing-sections-module__gkwj3G__section",
  "sectionAlt": "landing-sections-module__gkwj3G__sectionAlt",
  "statement": "landing-sections-module__gkwj3G__statement",
  "tag": "landing-sections-module__gkwj3G__tag",
  "tile": "landing-sections-module__gkwj3G__tile",
  "tileArrow": "landing-sections-module__gkwj3G__tileArrow",
  "tileFoot": "landing-sections-module__gkwj3G__tileFoot",
  "tileHead": "landing-sections-module__gkwj3G__tileHead",
  "tileItem": "landing-sections-module__gkwj3G__tileItem",
  "tileName": "landing-sections-module__gkwj3G__tileName",
  "tileText": "landing-sections-module__gkwj3G__tileText",
  "tiles": "landing-sections-module__gkwj3G__tiles",
});
